import { cloneDeep } from 'lodash-es';
import { deleteCacheByRequestId } from '@/utils/ls';

export default {
  namespaced: true,
  state: {
    currentIndex: -1,
    history: [],
  },
  mutations: {
    SET_CURRENTINDEX(state, payload) {
      state.currentIndex = payload;
    },
    ADD_STATE(state, payload) {
      const { $IS_FIRST, ...restPayload } = payload;
      // console.trace();
      if ($IS_FIRST) {
        state.history = [restPayload];
        state.currentIndex = 0;
        return;
      }
      if (state.currentIndex + 1 < state.history.length) {
        state.history.splice(state.currentIndex + 1);
      }

      const $payload = cloneDeep(payload);
      state.history.push($payload);
      state.currentIndex++;
    },
  },
  actions: {
    addState({ commit, rootState, state }, payload) {
      const { app } = rootState;
      const isappReady = app.appReady;
      const { $IS_FIRST, requestId, ...restPayload } = payload;

      const prevState = state.currentIndex === -1 ? {} : state.history[state.currentIndex];
      const isDiff = JSON.stringify(prevState) !== JSON.stringify(restPayload);
      if (isappReady && isDiff) {
        commit('ADD_STATE', {
          ...payload,
          requestId: rootState.multi.requestId,
        });
        console.log('-------', prevState, '->', payload);
      }
    },
    undo({ commit, dispatch, state }) {
      const prevState = state.history[state.currentIndex - 1];
      if (!prevState) return;
      console.log('undo');
      dispatch('app/replaceState', cloneDeep(prevState), { root: true });
      commit('SET_CURRENTINDEX', state.currentIndex - 1);
    },
    doAgain({ commit, state, rootState }) {
      const { requestId } = rootState.multi;
      deleteCacheByRequestId(requestId);
      state.history = [];
      state.currentIndex = 0;
      rootState.multi.againRequestId = requestId;
    },
    redo({ state, dispatch, commit }) {
      const nextState = state.history[state.currentIndex + 1];
      if (!nextState) return;
      console.log('redo');
      dispatch('app/replaceState', cloneDeep(nextState), { root: true });
      commit('SET_CURRENTINDEX', state.currentIndex + 1);
    },
  },
};
